import { Image } from 'expo-image';

import { awarenessLogo, type AwarenessLogoKind, type LogoBox } from '@/util/awarenessLogo';

/**
 * A Primum logo image, drawn with the awareness ribbon while that campaign runs. Pass the box the
 * plain logo had; the box is adjusted for the ribbon when it needs to be.
 */
export function AwarenessLogo({
  kind,
  box,
  alt,
}: {
  kind: AwarenessLogoKind;
  box: LogoBox;
  alt: string;
}) {
  const { source, style } = awarenessLogo(kind, box);

  return <Image alt={alt} source={source} contentFit="contain" style={style} />;
}
